import React from 'react';
import { Tooltip } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

const LightTooltip = props => {
    return (
        <CustomTooltip id='tooltip' interactive title={props.title}>
            {props.children}
        </CustomTooltip>
    );
}

const CustomTooltip = withStyles({
    tooltip: {
        backgroundColor: '#ececf5',
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: '0 5px 10px 0 rgba(192,192,222,0.43)',
        fontSize: 13,
        border: '1px solid #C0C0DE',
        borderRadius: '3px'
    }
})(Tooltip);

export default LightTooltip;